import { create } from 'zustand';

/**
 * Submitted master-search query for the client master list (SCRUM-1109).
 *
 * Lives in the shell-level SearchBar but is consumed by ClientsPage, and must
 * survive navigating into a client profile and back (tab close, sidebar link,
 * and the "+" button all land on bare `/clients`), so it can't live in the
 * URL or in ClientsPage state. Deliberately not persisted: a fresh session
 * starts with an empty search box and an unfiltered list.
 */
interface ClientSearchState {
  /** The query last submitted with Enter. Empty string = no filter. */
  query: string;
  setQuery: (query: string) => void;
  clear: () => void;
}

export const useClientSearchStore = create<ClientSearchState>(set => ({
  query: '',
  setQuery: query => set({ query: query.trim() }),
  clear: () => set({ query: '' }),
}));
